"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const E = require("fp-ts/lib/Either");
const O = require("fp-ts/lib/Option");
const pipeable_1 = require("fp-ts/lib/pipeable");
const NonEmptyArray_1 = require("fp-ts/lib/NonEmptyArray");
__export(require("./validators"));
function metaPath(path) {
    return lodash_1.toPath(metaProp(path.join('.')));
}
exports.metaPath = metaPath;
function metaProp(prop) {
    return `${prop}__meta`;
}
exports.metaProp = metaProp;
function maybeErrors(validation) {
    return pipeable_1.pipe(validation, E.fold(l => pipeable_1.pipe(l, NonEmptyArray_1.groupBy(x => x.path.join('.')), O.some), () => O.none));
}
exports.maybeErrors = maybeErrors;
